module.exports = __webpack_public_path__ + "ci_ssams.a5e18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_ssams.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_ssams.svg
// module chunks = main